import { Multiplier, SkillEnum } from '../types'

type SurfSpotMultipliers = {
  [key: string]: Multiplier[]
}

export const SURF_SPOTS: SurfSpotMultipliers = {
  // Mediterranean
  'Marina di Pietrasanta': [],
  'Capo Mannu': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'paddling' as SkillEnum, value: 1.1 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'whitewater_riding' as SkillEnum, value: 1.2 }
  ],
  Varazze: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'green_wave_riding' as SkillEnum, value: 1.2 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'popup' as SkillEnum, value: 1.2 }
  ],

  // France
  Hossegor: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'green_wave_riding' as SkillEnum, value: 1.3 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'whitewater_riding' as SkillEnum, value: 1.3 }
  ],
  Biarritz: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'paddling' as SkillEnum, value: 1.4 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'whitewater_riding' as SkillEnum, value: 1.3 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'fitness' as SkillEnum, value: 1.5 }
  ],
  'La Gravière': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'bottom_turn_front' as SkillEnum, value: 1.6 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'wave_reading' as SkillEnum, value: 1.4 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'popup' as SkillEnum, value: 0.8 }
  ],

  // Portugal
  Peniche: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'speed_control' as SkillEnum, value: 1.5 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'green_wave_riding' as SkillEnum, value: 0.85 }
  ],
  Nazaré: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'wave_reading' as SkillEnum, value: 2.0 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'paddling' as SkillEnum, value: 0.7 }
  ],
  Ericeira: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'bottom_turn_front' as SkillEnum, value: 1.4 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'whitewater_riding' as SkillEnum, value: 0.6 }
  ],

  // South Africa
  'Jeffreys Bay': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'cutback_front' as SkillEnum, value: 1.8 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'speed_generation' as SkillEnum, value: 1.6 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'bottom_turn_front' as SkillEnum, value: 0.75 }
  ],
  'Cape St. Francis': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'top_turn_front' as SkillEnum, value: 1.9 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'wave_reading' as SkillEnum, value: 1.7 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'green_wave_riding' as SkillEnum, value: 0.8 }
  ],
  Durban: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'top_turn_front' as SkillEnum, value: 1.8 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'top_turn_back' as SkillEnum, value: 1.5 }
  ],

  // California
  'Huntington Beach': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'cutback_back' as SkillEnum, value: 1.7 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'top_turn_front' as SkillEnum, value: 1.5 }
  ],
  Malibu: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'cutback_front' as SkillEnum, value: 1.8 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'top_turn_back' as SkillEnum, value: 1.6 }
  ],
  Trestles: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'aerial' as SkillEnum, value: 2.0 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'speed_control' as SkillEnum, value: 1.6 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'bottom_turn_back' as SkillEnum, value: 0.7 }
  ],

  // Australia East Coast
  'Byron Bay': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'speed_control' as SkillEnum, value: 1.9 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'cutback_back' as SkillEnum, value: 1.7 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'green_wave_riding' as SkillEnum, value: 1.75 }
  ],
  'Snapper Rocks': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'top_turn_back' as SkillEnum, value: 2.1 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'speed_generation' as SkillEnum, value: 1.8 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'barrel' as SkillEnum, value: 1.65 }
  ],
  'Gold Coast': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'barrel' as SkillEnum, value: 2.0 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'wave_reading' as SkillEnum, value: 1.7 }
  ],
  // Indonesia
  Uluwatu: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'barrel' as SkillEnum, value: 2.5 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'wave_reading' as SkillEnum, value: 2.2 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'paddling' as SkillEnum, value: 0.55 }
  ],
  'Padang Padang': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'speed_control' as SkillEnum, value: 2.3 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'barrel' as SkillEnum, value: 2.2 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'bottom_turn_back' as SkillEnum, value: 0.6 }
  ],
  'Mentawai Islands': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'barrel' as SkillEnum, value: 2.4 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'top_turn_front' as SkillEnum, value: 0.5 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'top_turn_back' as SkillEnum, value: 0.5 }
  ],
  // Australia West Coast (Adding missing spots)
  'Margaret River': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'barrel' as SkillEnum, value: 1.8 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'top_turn_front' as SkillEnum, value: 2.5 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'top_turn_back' as SkillEnum, value: 2.5 }
  ],
  'Australian Wave Pool': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'barrel' as SkillEnum, value: 2.5 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'aerial' as SkillEnum, value: 3.2 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'air_reverse' as SkillEnum, value: 3.2 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'speed_control' as SkillEnum, value: 2.1 }
  ],
  'North Point': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'cutback_back' as SkillEnum, value: 2.3 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'speed_control' as SkillEnum, value: 2.0 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'bottom_turn_front' as SkillEnum, value: 0.6 }
  ],
  // Hawaii
  Pipeline: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'barrel' as SkillEnum, value: 3.0 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'wave_reading' as SkillEnum, value: 2.5 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'paddling' as SkillEnum, value: 0.5 }
  ],
  'Waimea Bay': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'wave_reading' as SkillEnum, value: 2.8 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'paddling' as SkillEnum, value: 2.4 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'popup' as SkillEnum, value: 0.5 }
  ],
  'Honolua Bay': [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'cutback_back' as SkillEnum, value: 2.6 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'cutback_front' as SkillEnum, value: 2.6 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'speed_control' as SkillEnum, value: 2.2 }
  ],

  // Tahiti
  "Teahupo'o": [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'barrel' as SkillEnum, value: 3.0 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'wave_reading' as SkillEnum, value: 2.7 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'popup' as SkillEnum, value: 0.5 }
  ],
  Papara: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'aerial' as SkillEnum, value: 2.8 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'speed_generation' as SkillEnum, value: 2.6 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'speed_control' as SkillEnum, value: 0.5 }
  ],
  Taapuna: [
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'cutback_back' as SkillEnum, value: 2.5 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'cutback_front' as SkillEnum, value: 2.5 },
    { type: 'activeAtSurfSpot', effectCategory: 'skill', key: 'speed_control' as SkillEnum, value: 2.3 }
  ]
}
